// extracted by mini-css-extract-plugin
export default {"container":"CadastroRangeDePrecos_container__QOFC6","content":"CadastroRangeDePrecos_content__INveP","list":"CadastroRangeDePrecos_list__K5uDx"};